import { ChevronDownIconOutline } from '@neo4j-ndl/react/icons';

export function Details(props: React.PropsWithChildren<{ label: string }>) {
  return (
    <details className="[&_.revealable-marker]:open:rotate-180">
      <summary className="n-body-medium n-text-palette-primary-text flex cursor-pointer list-none items-center gap-1">
        <span>{props.label}</span>
        <ChevronDownIconOutline className="revealable-marker inline h-4 w-4 transition-all" />
      </summary>
      <div className="pt-2">{props.children}</div>
    </details>
  );
}
